<template>
    <div class="NetworkAnomaly">
        <div class="summitek-header">
            <div class="m-contain">
                <div class="logo" @click="toHome">
                    <img src="../../../assets/image/LOGO.png" alt="" />
                </div>
            </div>
        </div>
        <div class="content">
            <div class="img">
                <img src="../../../assets/image/networkAnomali.png" alt="">
            </div>
            <div class="notFount_characters">
                <div class="title">网络连接有误</div>
                <div>网络异常，请检查网络</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {

        };
    },
    computed: {
    },
    mounted() {
        // 设置全屏
        this.$store.commit("isFull", true);
    },
    watch: {},
    methods: {
        toHome() {
            this.$router.push({
                path: "/Home",
            });
        }
    },
};
</script>
<style lang="scss" scoped>
.NetworkAnomaly {
    position: relative;
    height: 100vh;
    z-index: 999;

    .summitek-header {
        height: 60px;
        width: 100%;
        min-width: 1180px;
        position: fixed;
        top: 0;
        z-index: 11;
        background-color: #fff;

        .m-contain {
            // width: 1200px;
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0 auto;
            padding: 0 100px;
        }

        .M_contain {
            width: 1200px;
        }

        .logo {
            width: 150px;
            font-size: 16px;
            font-weight: bold;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .content {
        display: flex;
        align-items: center;
        height: 100vh;
        background-color: rgb(248, 248, 248);
        padding-left: 15%;

        img {
            height: 400px;
            margin-right: 100px;
        }

        .notFount_characters {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(42, 30, 23, 1);
            text-align: left;
            vertical-align: top;
        }

        .title {
            font-size: 48px;
            font-weight: 500;
            letter-spacing: 0px;
            line-height: 48px;
            color: rgba(42, 30, 23, 1);
            text-align: left;
            vertical-align: top;
            margin-bottom: 24px;
        }
    }
}
</style>